// eslint-disable-next-line no-unused-vars
import { mapState } from "vuex";

export var faultTreeMixin = {
  computed: mapState(["rotationScreen", "user"]),

  data() {
    return {
      rotationRouter: {},
      indexRotation: 0,
      options: {},
      indicators: [],
      treeDataBkp: [],
      treeDecisionDataBkp: [],
      getTree: 0,
    };
  },

  watch: {},

  methods: {
    copyFrom(from) {
      if (!from) return {};
      let jsonTree = JSON.parse(from.tree);
      this.formatIdDecisionTree(jsonTree);
      return jsonTree;
    },

    formatIdDecisionTree(node, currentId = 1) {
      if (node.hasOwnProperty('id')) {
        node.id = currentId.toString();
        currentId++;
      }

      // Se o nó tiver filhos, chama a função recursivamente para cada um
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => {
          currentId = this.formatIdDecisionTree(child, currentId);
        });
      }

      // Retorna o próximo ID disponível
      return currentId;
    },

    formatIndicator(data) {
      let newList = new Array();
      data.forEach((i) => {
        let hasData = newList.find(
          (n) => n.id == i.id && n.productionUnitId == i.productionUnitId
        );
        if (!hasData) {
          newList.push({
            id: i.id,
            system: i.system,
            productionUnitId: i.productionUnitId,
            Indicador: i.indicatorName,
          });
        }
      });
      return newList;
    },
    findOnTree(tree, field, value) {
      for (const node of tree) {
        if (node[field] == value) {
          return node;
        }

        if (node.children && node.children.length > 0) {
          const result = this.findOnTree(node.children, field, value);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
  },
  destroyed() { },
};
